import {
    SET_PRODUCTS
  } from "redux/constants/portal";
  
  const initialState = {
    products: [],
  };
  
  const view = (state = initialState, { type, payload }) => {
    switch (type) {
      case SET_PRODUCTS:
        return {
          ...state,
          products: payload,
        };
    }
    return state;
  };
  
  export default view;
  